import React from 'react';

// Импортируем изображения для каждого этапа
import podbor1 from './podbor1.jpg';
import podbor2 from './podbor2-1.jpg';
import podbor3 from './podbor3.jpg';
import podbor4 from './podbor4.jpg';
import podbor5 from './podbor5.jpg';
import podbor6 from './podbor6.jpg';
import pordbor9 from './pordbor9.jpg';
import podbor8 from './podbor7.jpg'; // Используем то же изображение для этапа 8, замените на правильное если есть

const WorkSteps = ({ onOpenApplicationModal }) => {
    const steps = [
        {
            id: 1,
            title: 'Поиск авто по параметрам',
            description: 'Предлагаем варианты автомобилей максимально соответствующие запросам/требованиям (комплектация, технические характеристики и пожелания клиента) или выбираете с каталога самостоятельно',
            image: podbor1
        },
        {
            id: 2,
            title: 'Официальный договор',
            description: 'Подписываем официальный договор с указанием всех сроков.',
            image: podbor2
        },
        {
            id: 3,
            title: 'Таможенное оформление',
            description: 'Оформлением занимается брокер, сроки: 1-3дня',
            image: podbor3
        },
        {
            id: 4,
            title: 'Настраиваем логистику',
            description: 'Процесс занимает до 2-х дней.',
            image: podbor4
        },
        {
            id: 5,
            title: 'Передача новому владельцу',
            description: 'Подписываете акт приема-передачи автомобиля',
            image: podbor5
        },
        {
            id: 6,
            title: 'Проверка авто',
            description: 'Проверяете автомобиль на любом сервисе или с подборщиком',
            image: podbor6
        },
        {
            id: 7,
            title: 'Оформление в ГИБДД',
            description: 'С автомобилем приедет наш человек, который поможет полностью оформить автомобиль, получить номерные знаки в ГАИ.',
            image: podbor8
        },
        {
            id: 8,
            title: 'Жмем руки',
            description: 'Вы наслаждаетесь собственным автомобилем и рекомендуете нас вашим знакомым!',
            image: pordbor9
        }
    ];

    return (
        <div className="work-steps-section">
            <h2 className="work-steps-title">Этапы работы с нами</h2>

            <div className="work-steps-container">
                {steps.map((step) => (
                    <div className="work-step-item" key={step.id}>
                        <div className="step-image-container">
                            <div className="step-number">ЭТАП {step.id}</div>
                            <img
                                src={step.image}
                                alt={`Этап ${step.id}`}
                                className="step-image"
                            />
                        </div>
                        <div className="step-content">
                            <h3 className="step-title">{step.title}</h3>
                            <p className="step-description">{step.description}</p>
                        </div>
                    </div>
                ))}
            </div>

            <div className="work-steps-cta">
                <button
                    className="button primary application-button"
                    onClick={onOpenApplicationModal}
                >
                    Оставить заявку
                </button>
            </div>
        </div>
    );
};

export default WorkSteps;